import React from "react";
import TopbarItem from "./TopbarItem";
import styled from "styled-components";
import { flapOut } from "../../product/utils/z-index";

const MenuItemContainer = styled.div<{ active: boolean }>`
  position: fixed;
  top: 71px;
  width: 100vw;
  z-index: ${flapOut};
  height: 100vh;
  background: ${(props) => props.theme.colors.white};
  display: flex;
  margin: 0;
  flex-direction: column;
  transform: ${({ active }) =>
    active ? "translateX(0)" : "translateX(100vw)"};
  transition: 0.4s ease-in-out;

  @media (min-width: 1280px) {
    margin: 0 auto 0 40px;
    display: inherit;
    align-items: inherit;
    position: static;
    width: auto;
    height: auto;
    flex-direction: row;
  }
`;

const TopbarNav = (props: { active: boolean }): JSX.Element => {
  return (
    <MenuItemContainer active={props.active}>
      <TopbarItem
        title="Funktionen"
        items={[
          {
            title: "Digitale Personalakte",
            description: "Halten Sie Stammdaten stets aktuell.",
            link: "/dpf",
          },
          {
            title: "Zeiterfassung",
            description: "Erfassen Sie Arbeitszeiten gesetzeskonform.",
            link: "/time-tracking",
          },
          {
            title: "On- & Offboarding",
            description:
              "Ermöglichen Sie Ihren Mitarbeiterinnen den optimalen Start. ",
            link: "/on-boarding",
          },
          {
            title: "Abwesenheiten",
            description:
              "Verwalten Sie Abwesenheiten effizient und fehlerfrei. ",
            link: "/absence",
          },
          {
            title: "Alle neuen Funktionen",
            description: "Übersicht über alle neuen Funktionen in HeavenHR 2.0",
            link: "/hr",
          },
        ]}
      />
      <TopbarItem title="Entgeltabrechnung" link="/payroll" />
      <TopbarItem title="Preise" link="/prices" />
      <TopbarItem title="Blog" link="/blog" />
      <TopbarItem title="Über Uns" link="/about" />
      <TopbarItem title="Karriere" link="/careers" />
    </MenuItemContainer>
  );
};

export default TopbarNav;
